import React, { useEffect, useState } from "react";
import { Mail, MailOpen } from "lucide-react";
import api from "../../lib/apiClient";

// Owner inbox for the public contact form: every message is stored here even when email forwarding is not configured.
export default function ContactInbox() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/contact-messages").then((r) => setData(r.data)).catch(() => setData({ messages: [], unread: 0, error: true }));
  useEffect(() => { load(); }, []);
  const markRead = async (id) => { await api.post(`/admin/contact-messages/${id}/read`); load(); };
  if (!data) return <p className="text-sm text-ink-soft" data-testid="contact-inbox-loading">Loading messages…</p>;
  return (
    <section data-testid="contact-inbox" className="space-y-3">
      <h2 className="font-heading font-extrabold text-xl text-ink">Contact inbox <span className="text-sm font-body text-ink-soft">({data.unread} unread)</span></h2>
      <p className="text-xs text-ink-soft">Messages from the public form are always stored here. Each shows whether email forwarding to the contact mailbox was accepted, not configured, or failed.</p>
      {data.error && <p className="text-sm text-ink" role="alert">Couldn't load messages.</p>}
      {data.messages.length === 0 && !data.error && <p className="text-sm text-ink-soft" data-testid="contact-inbox-empty">No messages yet.</p>}
      {data.messages.map((m) => (
        <article key={m.id} className={`rounded-2xl border p-4 ${m.read_at ? "border-line bg-white" : "border-brand/30 bg-blush/40"}`} data-testid={`contact-msg-${m.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
            <span className="font-bold text-ink">{m.name} <a href={`mailto:${m.email}`} className="font-normal text-brand">{m.email}</a></span>
            <span className="text-xs text-ink-soft">{new Date(m.created_at).toLocaleString()} · forwarding: {m.delivery?.status || "unknown"}</span>
          </div>
          <p className="mt-2 whitespace-pre-wrap text-ink">{m.message}</p>
          {!m.read_at && <button type="button" onClick={() => markRead(m.id)} data-testid={`contact-msg-read-${m.id}`} className="mt-3 inline-flex min-h-[36px] items-center gap-1.5 rounded-full border border-line bg-white px-3 text-xs font-bold text-ink hover:border-brand/40"><MailOpen size={14} /> Mark read</button>}
          {m.read_at && <p className="mt-2 flex items-center gap-1 text-xs text-ink-soft"><Mail size={12} /> Read {new Date(m.read_at).toLocaleString()}</p>}
        </article>
      ))}
    </section>
  );
}
